// Modules
import xhr from 'modules/xhr';
// API
import { ENDPOINTS } from '../api.config';
// Types
import { TQueryParams, IResMessage } from 'types/appTypes';
import {
  ICreateCandidateBody,
  IGetCandidateRes,
  IGetCandidatesRes,
  ICreateCandidateRes,
  IUpdateCandidateBodyWithParam,
  IGetCandidateStatusesRes,
  ICreateCandidateStatusBody,
  ICreateCandidateStatusRes,
} from 'types/candidateTypes';

export const getCandidateList = (params: TQueryParams) => {
  return xhr.get<IGetCandidatesRes, IGetCandidatesRes>(`${ENDPOINTS.candidates}`, {
    params,
  });
};

export const getCandidate = (id: number) => {
  return xhr.get<IGetCandidateRes, IGetCandidateRes>(`${ENDPOINTS.candidates}/${id}`);
};

export const createCandidate = (body: ICreateCandidateBody) => {
  return xhr.post<ICreateCandidateRes, ICreateCandidateRes>(`${ENDPOINTS.candidates}`, body);
};

export const updateCandidate = ({ id, body }: IUpdateCandidateBodyWithParam) => {
  return xhr.put<IResMessage, IResMessage>(`${ENDPOINTS.candidates}/${id}`, body);
};

export const deleteCandidate = (id: number) => {
  return xhr.delete<IResMessage, IResMessage>(`${ENDPOINTS.candidates}/${id}`);
};

export const getCandidateStatuses = (params: TQueryParams) => {
  return xhr.get<IGetCandidateStatusesRes, IGetCandidateStatusesRes>(
    `${ENDPOINTS.candidateStatus}`,
    {
      params,
    },
  );
};

export const createCandidateStatus = (body: ICreateCandidateStatusBody) => {
  return xhr.post<ICreateCandidateStatusRes, ICreateCandidateStatusRes>(
    `${ENDPOINTS.candidateStatus}`,
    body,
  );
};

export const deleteCandidateStatus = (id: number) => {
  return xhr.delete<IResMessage, IResMessage>(`${ENDPOINTS.candidateStatus}/${id}`);
};
